import type { ComponentType, SVGProps } from 'react';
import { cn } from '@/lib/utils';

type SvgIconComponent = ComponentType<SVGProps<SVGSVGElement>>;

type BaseIconProps = Omit<SVGProps<SVGSVGElement>, 'children'> & {
    icon: SvgIconComponent;
};

export type IconProps =
    | (BaseIconProps & {
          decorative?: true;
          title?: string;
      })
    | (BaseIconProps & {
          decorative: false;
          title: string;
      });

export const Icon = ({ className, decorative = true, icon: SvgIcon, title, ...props }: IconProps) => {
    const hasNonEmptyTitle = typeof title === 'string' && title.trim().length > 0;

    if (!decorative && !hasNonEmptyTitle) {
        throw new Error('Icon component: `title` must be a non-empty string when `decorative` is false.');
    }

    return (
        <SvgIcon
            {...props}
            aria-hidden={decorative}
            aria-label={!decorative && title ? title : undefined}
            className={cn('shrink-0', className)}
            focusable="false"
            role={!decorative ? 'img' : undefined}
        />
    );
};
